// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo__Logo___38wHj"};